// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-header {
  display: flex;
  justify-content: space-between;
  padding: 1rem 24px;
  height: 100px;
}
.header-body {
  padding: 0;
  display: flex;
  list-style: none;
  align-items: center;
  margin-bottom: 0;
  font-weight: 500;
  gap: 28px;
}

.header-body li a {
  /* padding: 0 1rem; */
  text-decoration: none;
  color: var(--secondary);
  line-height: 29px;
  font-size: 12px;
}
.header-body li .active {
  color: var(--primary) !important;
}
.header-body li a:hover {
  color: var(--primary);
}

.mobile-hide {
  display: block;
}
.mobile-show {
  display: none;
}
.header-bottom {
  display: none;
}
.mobile-header-top {
  display: none;
}

.card-wallet {
  background: #fff;
  padding: 5px 10px;
}

.flex-btns{
  display: flex;
  align-items: center;
  /* justify-content: center; */
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B","sourcesContent":[".custom-header {\n  display: flex;\n  justify-content: space-between;\n  padding: 1rem 24px;\n  height: 100px;\n}\n.header-body {\n  padding: 0;\n  display: flex;\n  list-style: none;\n  align-items: center;\n  margin-bottom: 0;\n  font-weight: 500;\n  gap: 28px;\n}\n\n.header-body li a {\n  /* padding: 0 1rem; */\n  text-decoration: none;\n  color: var(--secondary);\n  line-height: 29px;\n  font-size: 12px;\n}\n.header-body li .active {\n  color: var(--primary) !important;\n}\n.header-body li a:hover {\n  color: var(--primary);\n}\n\n.mobile-hide {\n  display: block;\n}\n.mobile-show {\n  display: none;\n}\n.header-bottom {\n  display: none;\n}\n.mobile-header-top {\n  display: none;\n}\n\n.card-wallet {\n  background: #fff;\n  padding: 5px 10px;\n}\n\n.flex-btns{\n  display: flex;\n  align-items: center;\n  /* justify-content: center; */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
